import React, { lazy } from 'react';

// project imports
import AuthGuard from 'routes/route-guard/AuthGuard';
import MainLayout from 'views/layouts/MainLayout';
import Loadable from 'components/common/Loadable';

// Pages
const SamplePage = Loadable(lazy(() => import('views/pages/samplePage')));
const SessionRegistrationPage = Loadable(lazy(() => import('views/pages/sessions/sessionRegistrationPage')));
const SessionFeedbackPage = Loadable(lazy(() => import('views/pages/sessions/sessionFeedbackPage')));
const ProfilePage = Loadable(lazy(() => import('views/pages/profile/profilePage')));
const PreferencesPage = Loadable(lazy(() => import('views/pages/preferences/preferencesPage')));
const AskTheExpertPage = Loadable(lazy(() => import('views/pages/askTheExpert/askTheExpertPage')));
const UserSessionsViewPage = Loadable(lazy(() => import('views/pages/sessions/userSessionsPage')));
const UserAssessmentPage = Loadable(lazy(() => import('views/pages/assessments/userAssessmentPage')));
const Aboutpage = Loadable(lazy(() => import('views/pages/About/About')));


const MainRoutes = {
	path: '/',
	element: (
		<AuthGuard>
			<MainLayout />
		</AuthGuard>
	),
	children: [
		{
			path: '/assessments',
			element: <SamplePage title='Assessments' />
		},
		{
			path: '/user/assessment/:assessmentId',
			element: <UserAssessmentPage />
		},
		{
			path: '/event/registration/:eventId',
			element: <SessionRegistrationPage />
		},
		{
			path: '/event/feedback/:eventId',
			element: <SessionFeedbackPage />
		},
		{
			path: '/user/sessions',
			element: <UserSessionsViewPage />
		},
		{
			path: '/event/registration',
			element: <SamplePage title='User Sessions' />
		},
		{
			path: '/askTheExpert',
			element: <AskTheExpertPage />
		},
		{
			path: '/profile',
			element: <ProfilePage />
		},
		{
			path: '/preferences',
			element: <PreferencesPage />
		}
	]
};

export default MainRoutes;
